import type { DocumentTargetType } from '@nlc/contracts';

import type { UploadPhase } from '../../api/upload-queue.js';

/** Enum values from the contract, made readable: `job_file` becomes "Job file". */
export function targetLabel(targetType: DocumentTargetType): string {
  const words = targetType.replaceAll('_', ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
}

export function phaseLabel(phase: UploadPhase): string {
  switch (phase) {
    case 'queued':
      return 'Waiting to upload';
    case 'requesting':
      return 'Preparing upload';
    case 'uploading':
      return 'Uploading';
    case 'completing':
      return 'Verifying';
    case 'failed':
      return 'Needs retry';
  }
}

export function formatSize(bytes: number): string {
  if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${Math.max(1, Math.round(bytes / 1024))} KB`;
}
